export const EXPERIENCE_TYPE = [
  { value: 'one_to_one_call', name: 'One to One Call / Video Conferencing' },
  { value: 'in_person_meeting', name: 'In-Person Meetup' },
  { value: 'personalized_video', name: 'Personalized Video' },
  { value: 'socialmedia_follow_comment', name: 'Social Media Follow or Post' },
  { value: 'custom_experience', name: 'Custom Experience' }
];
export const ORDER_LABELS = {
  EXPERIENCE_OPTION: 'Experience Option',
  TOTAL_AMOUNT_PAID: 'Total Amount Paid',
  SCHEDULED_DATE_TIME: 'Scheduled Date & Time',
  LOCATION_TO_MEET: 'Location to Meet',
  ONE_TO_ONE_CALL: 'one_to_one_call',
  IN_PERSON_MEETING: 'in_person_meeting',
  PERSONALIZED_VIDEO: 'personalized_video',
  SOCIAL_MEDIA: 'socialmedia_follow_comment',
  CUSTOM_EXPERIENCE: 'custom_experience',
  ADD_TO_CALENDAR: 'Add to Calendar',
  DOWNLOAD_CALENDAR_INVITE: 'Download Calendar Invite (.ics)'
}
